import { Typography } from "@mui/material";
import React from "react";
import ServiceField from "./ServiceField";
import { SERVICE_REQUIREMENTS } from "../DeployWizard.consts";
import { ServiceGroupContainer } from "../DeployWizard.styles";

const ServiceGroup = ({
  title,
  services,
  formData,
  latestToggles,
  errors,
  onFieldChange,
  onValueChange,
  onLatestToggle,
  disabled
}) => {
  if (!services.length) return null;

  return (
    <ServiceGroupContainer>
      <Typography variant="subtitle1" color="text.800">
        {title}
      </Typography>
      {services.map((service) => (
        <ServiceField
          key={service.serviceKey}
          id={service.id}
          label={service.label}
          value={formData[service.id] || ""}
          isLatest={latestToggles[service.id] || false}
          onValueChange={onValueChange}
          onLatestToggle={onLatestToggle}
          error={errors[service.id]}
          helperText={errors[service.id] || ""}
          disabled={disabled}
          showLatestToggle={service.showLatestToggle}
          modeSelector={service.modeSelector}
          extraFields={service.extraFields}
          formData={formData}
          errors={errors}
          onFieldChange={onFieldChange}
          required={service.requirement === SERVICE_REQUIREMENTS.REQUIRED}
          subtitle={service.subtitle}
        />
      ))}
    </ServiceGroupContainer>
  );
};

export default ServiceGroup;
